import showAssignVehicleForm from './assignVehicleFormHandler';
import showAlert from '../alert/alertHandler';
import axios from 'axios';

import preassignmentEnUS from '../locales/en-US/preassignment.json';
import preassignmentEsCL from '../locales/es-CL/preassignment.json';
import preassignmentEsMX from '../locales/es-MX/preassignment.json';
import preassignmentEsCO from '../locales/es-CO/preassignment.json';

export default {
  name: 'VehiclePreassignment',
  i18n: {
    messages: {
      'en-US': { preassignment: preassignmentEnUS },
      'es-CL': { preassignment: preassignmentEsCL },
      'es-MX': { preassignment: preassignmentEsMX },
      'es-CO': { preassignment: preassignmentEsCO },
    },
  },
  data() {
    return {
      isFilterClicked: false,
      isFilterShown: false,
      isFilterApplied: false,
      dataAccess: null,
      isBusy: false,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 50, 100],
      sortBy: '',
      sortDesc: false,
      keyword: '',
      rows: 0,
      rawVehicles: [],
      rawClients: [],
      rawUsers: [],
      vehicles: [],
      drivers: [],
    };
  },
  async created() {
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      this.isBusy = true;
      const driverPromise = this.getDrivers();
      const vehiclePromise = this.getVehicles();
      const clientPromise = this.getClients();
      const vehicleAssignmentsPromise = this.getVehicleAssignments();
      const [driverResult, vehicleResult, clientResult, vehicleAssignmentsResult] = await Promise.all([
        driverPromise,
        vehiclePromise,
        clientPromise,
        vehicleAssignmentsPromise,
      ]);
      this.vehicles = this.processVehicles(vehicleResult, clientResult);
      this.drivers = this.processDrivers(driverResult, clientResult, vehicleResult, vehicleAssignmentsResult);
      this.rows = this.drivers.length;
      this.isBusy = false;
    },
    async openAssignmentForm(driver) {
      let assignedVehicles = [];
      this.drivers.forEach((dr) => {
        if (driver.id != dr.id && dr.vehicles) {
          dr.vehicles.forEach((veh) => {
            assignedVehicles.push(veh.plate);
          });
        }
      });
      let vehiclesWithoutDriver = [];
      vehiclesWithoutDriver = this.vehicles.filter((element) => !assignedVehicles.includes(element.plate));
      console.log('id driver', driver.id, this.drivers);
      showAssignVehicleForm(
        this.drivers.find((d) => d.id === driver.id),
        vehiclesWithoutDriver,
        (selectedVehicles) => {
          this.updateDriverVehicles(driver, selectedVehicles);
          showAlert(
            this.$t('preassignment.formulario.tabla.exito.titulo'),
            this.$t('preassignment.formulario.tabla.exito.mensaje'),
          );
        },
      );
    },
    async getDrivers() {
      this.keyword = '';
      const urlDrivers = `${this.$store.getters.urlAPI}/api/driver?provider=true`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let driverPromise = await axios.get(urlDrivers, config);
        return driverPromise.data.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getClients() {
      const urlClients = `${this.$store.getters.urlAPI}/api/client/all`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        let clientPromise = await axios.get(urlClients, config);
        return clientPromise.data.data;
      } catch (e) {
        console.log(e);
        return [this.$store.getters.client];
      }
    },
    async getVehicles() {
      const enterprise = this.readCookie('enterprise');
      let urlVehicles = `${this.$store.getters.urlAPI}/api/vehicle?provider=true`;
      if (enterprise === 'false'){
        urlVehicles = `${this.$store.getters.urlAPI}/api/vehicle?provider=true&requireEnabledSystem=LML&includeTags=true`;
      }
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const vehiclePromise = await axios.get(urlVehicles, config);
        return vehiclePromise.data.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getVehicleAssignments() {
      const urlAssignments = `${this.$store.getters.urlAPI}/driverVehicle`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const vehicleAssignmentsPromise = await axios.get(urlAssignments, config);
        console.log(vehicleAssignmentsPromise)
        return vehicleAssignmentsPromise.data.data;
      } catch (e) {
        console.log(e);
        console.log(e.response);
      }
    },
    processVehicles(rawVehicles, rawClients) {
      return rawVehicles.map((v) => {
        const client = rawClients.find((c) => c.id === v.idClient);
        return {
          ...v,
          client: {
            ...v.client,
            name: client ? client.name : '',
          },
        };
      });
    },
    processDrivers(rawDrivers, rawClients, rawVehicles, rawAssignments) {
      return rawDrivers.map((d) => {
        const client = rawClients.find((c) => c.id === d.idClient);
        const vehicleIds = rawAssignments.find((a) => a.idDriver === d.id);
        let vehicles = [];
        if (vehicleIds) {
          const findVehicle = vehicleIds.idVehicle.map((v) => {
            return rawVehicles.find((rv) => rv.id === v);
          });
          vehicles = findVehicle && !findVehicle.includes(undefined) ? findVehicle : [];
        }
        return {
          ...d,
          client: {
            ...d.client,
            name: client ? client.name : '',
          },
          vehicles,
        };
      });
    },
    updateDriverVehicles(driverData, selectedVehicleIds) {
      this.drivers.forEach((d) => {
        if (d.id === driverData.id) {
          d.vehicles = selectedVehicleIds.map((v) => {
            return this.vehicles.find((rv) => rv.id === v);
          });
        }
      });
    },
    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    readCookie(name) {
      return (
        decodeURIComponent(
          document.cookie.replace(
            new RegExp('(?:(?:^|.*;)\\s*' + name.replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'),
            '$1',
          ),
        ) || null
      );
    },
  },
  computed: {
    items() {
      this.isFilterApplied = false;
      if (this.keyword) {
        this.isFilterApplied = true;
      }

      return this.drivers.map((d) => {
        return {
          id: d.id,
          username: this.transformWords(d.firstName) + ' ' + this.transformWords(d.lastName),
          client: d.client.name,
          assignedVehicles: d.vehicles,
        };
      });
    },
    fields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
        sortable: true,
      };
      return [
        {
          key: 'username',
          label: this.$t('preassignment.tabla.cabeceras.usuario'),
          ...common,
        },
        {
          key: 'client',
          label: this.$t('preassignment.tabla.cabeceras.empresa'),
          ...common,
        },
        {
          key: 'assignedVehicles',
          label: this.$t('preassignment.tabla.cabeceras.vehiculoAsignado'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('preassignment.tabla.cabeceras.acciones'),
          ...common,
          sortable: false,
        },
      ];
    },
  },
};
